'use strict'

import React from 'react'

export default class Menu extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      clicked: false
    }
  }

  click () {
    this.setState({
      clicked: !this.state.clicked
    })
  }

  render () {
    return (
      <span onClick={this.click.bind(this)} className="quote menu-button">
        Menu
        <ul style={{visibility: this.state.clicked ? 'visible' : 'hidden', opacity: this.state.clicked ? 1 : 0}}>
          <li><a href="/about-dma/faq">FAQs</a></li>
          <li onClick={this.props.startForm}><a>Buy a Voucher & Save</a></li>
          <li onClick={this.props.startQuote}><a>Get a Dental Quote</a></li>
          <li onClick={this.props.startFind}><a>Find a Dentist</a></li>
          <li><a href="/about-dma">About DMA</a></li>
          <li><a href="/contact">Contact DMA</a></li>
          <li><a href="">Log In</a></li>
        </ul>
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/assets/menu.js